import { render, staticRenderFns } from "./CloseFormula.vue?vue&type=template&id=a953f360&scoped=true"
import script from "./CloseFormula.vue?vue&type=script&lang=js"
export * from "./CloseFormula.vue?vue&type=script&lang=js"
import style0 from "./CloseFormula.vue?vue&type=style&index=0&id=a953f360&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a953f360",
  null
  
)

export default component.exports